<template>
  <div>
    <div id="myChart_lin" :style="{width: '100%', height: '600px'}"></div>
    <div class="zhe_boots" style="    text-align: center;">
      <el-radio-group v-model="channelidType" @change="channelidTypeL">
        <el-radio-button
          :label="'channel'+item.channelid"
          v-for="item in channelid"
          :key="item.channelid"
        >{{lang_file == 'zh-cn'?item.unittype:item.unittype_en}}</el-radio-button>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataX: {
      type: Array,
      default: []
    },
    collecttime: {
      type: Array,
      default: []
    },
    channelid: {
      type: Array,
      default: []
    },
    titleObj: {
      type: Object,
      default: {}
    },
    teab: {
      type: String,
      default: ""
    }
  },
  watch: {
    dataX: {
      handler(val) {
        console.log(val);
        
        this.drawLine(val, this.collecttime);
      }
    },
    teab:{
      handler(val){
        this.channelidType = val
      },
      deep:true
    },
  },
  data() {
    return {
      objUnit: {},
      dataXlist: this.dataX,
      channelidType: this.teab,
      // lang_file: sessionStorage.getItem("lang_file"),
    };
  },
  created() {},
  mounted() {
    this.lang_file = sessionStorage.getItem("lang_file")
    this.drawLine();
  },
  methods: {
    channelidTypeL(e) {
      let splNew = e.split("l")[1];
      this.$emit("channelidfuntEnd", e);
      /**获取标题  */
      this.channelid.forEach(item => {
        console.log(item.unittype_en);
        
        if (item.channelid == splNew) {
          this.objUnit = {
            unit: item.unit,
            unittype:lang_file == 'zh-cn'? item.unittype:item.unittype_en
          };
        }
      });
    },
    drawLine(data, time) {
      let myChart = this.$echarts.init(document.getElementById("myChart_lin"));
      let unt =
        this.objUnit.unit == undefined ? this.titleObj.unit : this.objUnit.unit;
        
      // 绘制图表
      let option = {
        title: {
          left: "center",
          text:
            this.objUnit.unittype == undefined
              ? this.titleObj.unittype
              : this.objUnit.unittype
          //   subtext: '纯属虚构'
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          // left: 10,
          //   data: ['最高气温',]
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {}
          }
        },
        xAxis: {
          // value || this.collecttimeList
          type: "category",
          boundaryGap: false,
          data: time || this.collecttime
        },
        yAxis: {
          // name:'11',
          type: "value",
          axisLabel: {
            formatter: "{value}" + unt
          }
        },

        series: [
          {
            // name: '最高气温',
            smooth: true, //这个是把线变成曲线
            type: "line",
            data: data || this.dataX,
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" }
              ]
            },
            markLine: {
              data: [{ type: "average", name: "平均值" }]
            }
          }
          // {
          //     name: '最低气温',
          //     type: 'line',
          //     data: [1, -2, 2, 5, 3, 2, 0],
          //     markPoint: {
          //         data: [
          //             {name: '周最低', value: -2, xAxis: 10, yAxis: -1.5}
          //         ]
          //     },
          //     markLine: {
          //         data: [
          //             {type: 'average', name: '平均值'},
          //             [{
          //                 symbol: 'none',
          //                 x: '90%',
          //                 yAxis: 'max'
          //             }, {
          //                 symbol: 'circle',
          //                 label: {
          //                     position: 'start',
          //                     formatter: '最大值'
          //                 },
          //                 type: 'max',
          //                 name: '最高点'
          //             }]
          //         ]
          //     }
          // }
        ]
      };
      myChart.setOption(option);
      // }
    }
  }
};
</script>

<style scoped>
</style>
